import { render, staticRenderFns } from "./DxViewTreePlanning.vue?vue&type=template&id=0f2584f9&scoped=true&"
import script from "./DxViewTreePlanning.vue?vue&type=script&lang=js&"
export * from "./DxViewTreePlanning.vue?vue&type=script&lang=js&"
import style0 from "./DxViewTreePlanning.vue?vue&type=style&index=0&id=0f2584f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2584f9",
  null
  
)

export default component.exports